import { combineReducers } from "redux";
import adminReducer from "./admin-reducer";

export default combineReducers({
    Reducer: adminReducer,
})